function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "17.33",
  cy: "17.33",
  r: "17.33",
  strokeLinecap: "square",
  strokeWidth: "1.73",
  transform: "translate(6.67 6.67)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  strokeWidth: ".5",
  d: "M20.06 33.33V24.9h2.53c.37 0 .65.04.82.12.18.08.35.21.5.4h0l6.2 7.58c.1.12.2.21.3.26.1.06.23.08.37.08H32l-6.65-8.07c-.18-.22-.37-.4-.59-.53.85-.09 1.6-.27 2.28-.56a5.89 5.89 0 001.73-1.1 4.58 4.58 0 001.48-3.5c0-1.6-.55-2.83-1.65-3.66-1.1-.83-2.77-1.24-5-1.24h0-4.93v18.66h1.39zm3.36-9.44h-3.36v-8.15h3.54c1.72 0 3.03.32 3.93.96.9.64 1.36 1.63 1.36 2.95a3.7 3.7 0 01-1.44 3.09c-.48.37-1.05.65-1.73.85-.68.2-1.44.3-2.3.3h0z"
}))));